module.exports = __webpack_public_path__ + "static/avatar-cdb19d946636eb3dfb103b21fdd4082c.svg";